import axios from 'axios';

import { LOBSTR_VAULT_API_URL } from 'constants/api';

export function sentToVault(xdr: string, signal?: AbortSignal) {
    const headers = { 'Content-Type': 'application/json' };

    return axios.post(LOBSTR_VAULT_API_URL, JSON.stringify({ xdr }), {
        headers,
        signal,
        timeout: 15000,
    });
}

export interface VaultChallengeResponse {
    xdr: string;
    network_passphrase: string;
}

export const getVaultChallenge = (hash: string, signal?: AbortSignal) =>
    axios
        .get<VaultChallengeResponse>(`${LOBSTR_VAULT_API_URL}${encodeURIComponent(hash)}`, {
            signal,
            timeout: 15000,
        })
        .then(response => response.data);
